import {StarMetricButton} from "@buildwithflux/project-cards";
import {useCallback} from "react";

import {writeStar} from "../../api/relationshipApi";
import {useViewer} from "../../context/ViewerContext";
import {useStarState} from "../../hooks/useRelationship";
import {gotoSignUp} from "../../utils/auth";

/**
 * Stateful star control for the search cards: wires the shared, purely
 * presentational StarMetricButton to the viewer's star relationship, with an
 * optimistic toggle and a signup redirect for logged-out viewers.
 */
export default function StarMetricControl(props: {documentUid: string; count?: number}) {
    const {documentUid, count} = props;
    const {uid: viewerUid, authResolved} = useViewer();
    const {active, setOptimistic} = useStarState(documentUid, viewerUid);

    const starred = active === true;
    // Until auth and the star relationship are known, the control stays inert:
    // a signed-in viewer clicking early would otherwise be sent to signup and
    // an already-starred project would be re-starred instead of unstarred.
    const resolved = viewerUid != null ? active !== undefined : authResolved;

    const onClick = useCallback(() => {
        if (!viewerUid) {
            gotoSignUp();
            return;
        }
        const next = !starred;
        setOptimistic(next);
        void writeStar(next ? "star" : "unstar", documentUid).catch(() => {
            setOptimistic(!next);
        });
    }, [viewerUid, starred, setOptimistic, documentUid]);

    return (
        <StarMetricButton
            starred={starred}
            count={count}
            disabled={!resolved}
            onClick={onClick}
            data-cy={starred ? "unstarButton" : "starButton"}
        />
    );
}
